import type { JSX, Ref } from 'react'

import { TextBoxMaxLine1Caption4 } from 'atoms/TextBox/Templates'
import { TimeLineIndicatorSC } from 'blocks/TimeLine/TimeLine.styled'

export interface ITimeLineIndicator {
  ref?: Ref<HTMLDivElement>
  title: string
}

export function TimeLineIndicator({ title, ref }): JSX.Element {
  return (
    <TimeLineIndicatorSC ref={ref}>
      <TextBoxMaxLine1Caption4 title={title} />
    </TimeLineIndicatorSC>
  )
}
